import React, { Component } from 'react';

class IconSidebarItemIssueCategory extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    stroke={this.props.isActive ? "#26A" : "#424242"}
                    d="M6.288 2.581h0l.01-.002c.28-.052.581-.079.895-.079H9.804c.232 0 .351.066.412.126.06.06.125.177.125.4v8.187c0 .224-.064.342-.125.403-.06.06-.175.124-.392.124H3.007c-.2 0-.316-.062-.38-.127-.065-.064-.127-.18-.127-.38V7.046c.01-2.182 1.643-4.105 3.788-4.466zm-2.92 7.771v.5h6.086V3.378h-2.31a3.754 3.754 0 00-3.776 3.786v3.188z"
                ></path>
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    d="M20.983 10.841c.626 0 1.008-.381 1.008-1.007v-.42-2.368c0-.264-.02-.489-.06-.713C21.512 3.79 19.4 2 16.808 2h-3.98c-.685 0-1.056.372-1.056 1.046v6.749c0 .665.38 1.046 1.036 1.046h8.176zm-.85-2.26v.392h-6.475V3.868h3.208c1.829 0 3.266 1.438 3.266 3.276v1.438zM22 12.777c0-.625-.391-1.017-1.027-1.017h-6.797c-.645 0-1.027.382-1.027 1.037V18.01c.01.88.01 1.79-.01 2.68-.01.488.079.811.294 1.026.195.196.479.284.89.284h.117c.401-.02.812-.01 1.223-.01.586.01 1.193.01 1.79-.049 2.532-.225 4.518-2.415 4.527-4.988v-3.031l.02-1.145zm-1.868 1.81v2.24c0 1.877-1.418 3.285-3.296 3.295h-1.799v-6.484h5.095v.949zM11.213 13.159H3.017c-.636 0-1.017.381-1.017 1.017V16.944c0 .283.02.518.059.733C2.509 20.259 4.592 22 7.222 22h3.971c.665 0 1.047-.382 1.047-1.037v-6.768c0-.655-.392-1.036-1.027-1.036zm-.86 1.877v5.096H7.173c-1.878 0-3.306-1.418-3.306-3.306v-1.79h6.484z"
                ></path>
            </svg>
        );
    }
}

export default IconSidebarItemIssueCategory;